import React from 'react'
import { Col, Collapse, Row } from 'antd'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import './CustomAccordion.scss'
import OrderHistoryTable from '../OrderDetailModalFooter/OrderHistoryTable'
import OrderCommmetTable from '../OrderDetailModalFooter/OrderCommentTable'
import { t } from 'i18next'

const { Panel } = Collapse

const CustomAccordion = () => {
  const customExpandIcon = ({ isActive }: { isActive: boolean }) =>
    isActive ? (
      <MinusOutlined className="custom-accordion__icon" />
    ) : (
      <PlusOutlined className="custom-accordion__icon" />
    )

  return (
    <Collapse
      expandIcon={customExpandIcon}
      expandIconPosition="end"
      bordered={false}
      className="custom-accordion"
    >
      <Panel
        header={
          <div className="custom-accordion__header">
            <span className="custom-accordion__title">{t('orders.history')}</span>
            <div className="custom-accordion__line" />
          </div>
        }
        key="1"
        className="custom-accordion__panel"
      >
        <Row
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '16',
          }}
        >
          <Col span={16}>
            <OrderHistoryTable />
          </Col>

          <Col span={7}>
            <OrderCommmetTable />
          </Col>
        </Row>
      </Panel>
    </Collapse>
  )
}

export default CustomAccordion
